import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import timeago from 'timeago.js';
Vue.prototype.$timeago = timeago;
Vue.prototype.$nFormat = function (number) {
    var SI_POSTFIXES = ["", "k", "M", "G", "T", "P", "E"];
    var tier = Math.log10(Math.abs(number)) / 3 | 0;
    if (tier == 0)
        return number;
    var postfix = SI_POSTFIXES[tier];
    var scale = Math.pow(10, tier * 3);
    var scaled = number / scale;
    var formatted = scaled.toFixed(1) + '';
    if (/\.0$/.test(formatted))
        formatted = formatted.substr(0, formatted.length - 2);
    return formatted + postfix;
};
import Auth from './packages/auth/Auth';
import Snackbar from './packages/snackbar/index';
Vue.use(Auth);
Vue.use(Snackbar);
import VueSocketio from "vue-socket.io";
Vue.use(VueSocketio, ':3000');
import Vuetify from 'vuetify';
Vue.use(Vuetify, {
    theme: {
        primary: "#1976d2",
        secondary: "#fb8c00",
        accent: "#ff5252",
        info: "#42a5f5",
        warning: "#ffa000",
        error: "#d50000",
        success: "#81c784",
    }
});
import VeeValidate from "vee-validate";
Vue.use(VeeValidate);
import './stylus/main.styl';
import LayoutPage from "@/components/Layouts/LayoutPage";
Vue.component('layout-page', LayoutPage);
import BaseBtn from "@/components/AppBtn";
Vue.component('app-btn', BaseBtn);
import AppGridList from "./components/AppGridList";
Vue.component('app-grid-list', AppGridList);
Vue.config.productionTip = false;
router.beforeEach(function (to, from, next) {
    if ((to.matched[0].meta.length === 0)) {
        return next();
    }
    if (to.matched[0].meta.forAuth) {
        if (!Vue.auth.isAuthenticated()) {
            return next({ path: "/login" });
        }
    }
    if (to.matched[0].meta.forAuth === false) {
        if (Vue.auth.isAuthenticated()) {
            return next({ path: "/" });
        }
    }
    return next();
});
Vue.prototype.$deepcopy = function (o) {
    return JSON.parse(JSON.stringify(o));
};
new Vue({
    el: '#app',
    router: router,
    store: store,
    render: function (h) { return h(App); }
});



//////////////////
// WEBPACK FOOTER
// ./src/main.ts
// module id = 275
// module chunks = 0